"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSkuInfoById = exports.getProductInfoById = exports.getSkus = exports.getIsLoading = exports.getSkuKeysMap = exports.getProducts = void 0;
var reselect_1 = require("reselect");
var getProducts = function (state) {
    var _a;
    return (_a = state.ejsProducts) === null || _a === void 0 ? void 0 : _a.products;
};
exports.getProducts = getProducts;
var getSkuKeysMap = function (state) {
    var _a;
    return (_a = state.ejsProducts) === null || _a === void 0 ? void 0 : _a.skuKeysMap;
};
exports.getSkuKeysMap = getSkuKeysMap;
var getIsLoading = function (state) {
    var _a;
    return (_a = state.ejsProducts) === null || _a === void 0 ? void 0 : _a.isLoading;
};
exports.getIsLoading = getIsLoading;
exports.getSkus = (0, reselect_1.createSelector)(exports.getProducts, exports.getSkuKeysMap, function (items, skuKeysMap) {
    return Object.keys(skuKeysMap || {}).reduce(function (acc, skuKey) {
        var _a;
        var productKey = skuKeysMap[skuKey];
        var product = items[productKey];
        var skuObj = product === null || product === void 0 ? void 0 : product.skus.find(function (sku) { return sku.id === skuKey; });
        if (skuObj) {
            return __assign(__assign({}, acc), (_a = {}, _a[skuKey] = {
                product: product,
                sku: skuObj,
            }, _a));
        }
        return acc;
    }, {});
});
exports.getProductInfoById = (0, reselect_1.createSelector)(exports.getProducts, function (items) {
    return function (id) {
        return items[id];
    };
});
exports.getSkuInfoById = (0, reselect_1.createSelector)(exports.getProducts, exports.getSkuKeysMap, function (items, skuKeysMap) {
    return function (id) {
        var _a;
        return ({
            product: items[id],
            sku: (_a = items[skuKeysMap[id]]) === null || _a === void 0 ? void 0 : _a.skus.find(function (sku) { return sku.id === id; }),
        });
    };
});
